export default __webpack_public_path__ + "static/Believe-c88a196944b3e9a49dcea1e33892dca1.mp3";